var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { iconLibrary } from './iconLibrary';
import { cn } from '../../utils';
export const Icon = (_a) => {
    var { name, className } = _a, props = __rest(_a, ["name", "className"]);
    const SelectedIcon = iconLibrary[name];
    return _jsx(SelectedIcon, Object.assign({ className: cn('inline', className) }, props));
};
